export enum MediaGalleryItemType {
    IMAGE = "ImageGalleryBlockProxy",
    VIDEO = "VideoGalleryBlockProxy"
}

/**
 * Represents one item in the carousel.
 */
export interface IMediaGalleryImage {
    image: string;
    caption: string;
}

export interface IMediaGalleryVideo {
    youtubeId: string;
    caption: string;
}

export interface IMediaGalleryItem {
    key: number;
    type: MediaGalleryItemType,
    seasonTag: string,
    productionSeasonId: number;
    productionName: string;
    buttonText: string;
    media: (IMediaGalleryImage | IMediaGalleryVideo)[];
    galleryTitle: string;
}

export interface IMediaGalleryFilterResponse {
    productionToSeason: { [productionId: string]: string[] };
    seasonToProduction: { [seasonTag: string]: string[] };
    seasons: string[];
    productions: string[];
}


// WEBPACK FOOTER //
// ./app/classes/media-gallery.ts